import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import qs from 'query-string';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { viewDocument } from '../../actions/DocumentViewerActions';
import { compareDocument, compareDocumentContentHistory } from '../../api/document';
import FileViewer from '../../components/FileViewer';
import Layout from '../../components/Layout';
import withSubmitFormDialog from '../../components/withSubmitFormDialog';
import { isTrue } from '../../utils/commonUtils';

const useStyles = makeStyles({
  panelContainer: {
    height: 'calc(100vh - 178px)',
  },
  docViewer: {
    height: '100%',
  },
});

function DocumentCompare({ location }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const qsParams = qs.parse(location.search) || {};
  const {
    docId,
    compareDocId,
    filename,
    buildNumberA,
    buildNumberB,
    documentType = '',
    isForDownload = false,
    preview,
  } = qsParams;
  const isCompareBuilds = !!(buildNumberA && buildNumberB);

  useEffect(() => {
    dispatch(viewDocument({ docId, contentType: documentType }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const params = {
    docId,
    isForDownload: isTrue(isForDownload),
  };

  if (isCompareBuilds) {
    params.buildNumberA = buildNumberA;
    params.buildNumberB = buildNumberB;
    params.preview = isTrue(preview);
  } else {
    params.compareDocId = compareDocId;
    params.documentType = documentType;
  }

  const fileViewer = (
    <div className={classes.docViewer}>
      {docId && (
        <FileViewer
          filename={filename}
          params={params}
          getFileContents={isCompareBuilds ? compareDocumentContentHistory : compareDocument}
          isDocCompare
        />
      )}
    </div>
  );

  return (
    <Layout>
      <Grid container>
        <Grid item xs={12}>
          <div className={classes.panelContainer}>{fileViewer}</div>
        </Grid>
      </Grid>
    </Layout>
  );
}

export default withSubmitFormDialog(DocumentCompare);
